module.exports = __webpack_public_path__ + "img/liondesk-logo.c3da77fe.png";